// For full API documentation, including code examples, visit https://wix.to/94BuAAs
import wixLocation from 'wix-location';
import wixWindow from 'wix-window';

$w.onReady(function () {
	//TODO: write your page related code here...
	

	$w("#html1").onMessage((event)=>{
	console.log("This definately happened!");
		if(event.data.type === 'ready'){
			console.log("Ready!")
			// do nothing yet, this is where the iframe is fully loaded
		}
		
		if(event.data.type === 'HTMLButtonElement.onclick'){
			// If clicked inside the html iframe execute this
			
			console.log(event.data.value);
			console.log("lets navigate to the other page now");
			wixLocation.to(event.data.value);
			$w('#input1').placeholder="פםןו";
			console.log("This also happened!");
			
			
		}
	});	


});



export function button21_click(event) {
	//Add your code for this event here: 
	$w('#html1').src= 'https://chita-il.com//RunCom.Server/Request.aspx?PRGNAME=nekudot_haluka&ARGUMENTS=-A' + $w("#input1").value + ',-A,-N,-A';
	$w('#html1').rendered;
	console.log("This happened!");

	//dialogDiv
	
	
}